import { combineReducers } from 'redux';

import { createResourceModuleReducerMap } from 'medialoopster/rest';

import { TranscriptUnitRootState } from './types';

export default combineReducers<TranscriptUnitRootState>(
  createResourceModuleReducerMap('transcriptunit', 'units'),
);
